import { useState } from "react";
import { Sheet, SheetContent, SheetTrigger } from "../ui/sheet";
import { Menu } from "lucide-react";
import { Separator } from "../ui/separator";
import { Link } from "react-router-dom";
import { useAuth } from "./contexts/auth-context";
import { Button } from "../ui/button";
// import { publicNavLinks, authenticatedNavLinks } from "./nav-links";

export const publicNavLinks = [
	{ label: "Home", to: "/" },
	{ label: "About Us", to: "/about" },
	{ label: "Courses", to: "/courses" },
	{ label: "Partners", to: "/partners" },
	{ label: "Contact Us", to: "/contact" },
	{ label: "Pricing", to: "/subscription" },
	{
		label: "Donate",
		to: "https://www.gofundme.com/f/empower-nigerian-kids-with-virtual-learning-join-us",
	},
];

export const authenticatedNavLinks = [
	{ label: "Dashboard", to: "/dashboard" },
	{ label: "Profile", to: "/profile" },
	{ label: "Settings", to: "/settings" },
];

export function MobileNav() {
	const [open, setOpen] = useState(false);
	const { isAuthenticated, logout } = useAuth();

	const handleLogout = () => {
		setOpen(false);
		logout();
	};

	const handleNavClick = () => setOpen(false);

	return (
		<Sheet open={open} onOpenChange={setOpen}>
			<SheetTrigger asChild>
				<Button variant="outline" size="icon" className="md:hidden">
					<Menu className="h-5 w-5" />
					<span className="sr-only">Toggle menu</span>
				</Button>
			</SheetTrigger>
			<SheetContent side="left" className="w-[300px] sm:w-[400px]">
				<nav className="flex flex-col gap-4 mt-8 p-4">
					{publicNavLinks.map((item) => {
						return (
							<Link
								key={item.to}
								to={item.to}
								className="text-lg font-medium transition-colors hover:text-primary"
								onClick={handleNavClick}>
								{item.label}
							</Link>
						);
					})}

					<Separator className="my-2" />

					{isAuthenticated ? (
						<>
							{authenticatedNavLinks.map((item) => (
								<Link
									key={item.to}
									to={item.to}
									className="text-lg font-medium transition-colors hover:text-primary"
									onClick={handleNavClick}>
									{item.label}
								</Link>
							))}
							<Button
								variant="outline"
								className="mt-2"
								onClick={handleLogout}>
								Log out
							</Button>
						</>
					) : (
						<div className="flex flex-col gap-2 mt-2">
							<Button asChild variant="outline">
								<Link to="/auth/login" onClick={handleNavClick}>
									Login
								</Link>
							</Button>
							<Button
								asChild
								className="bg-yellow-500 hover:bg-yellow-600 text-white">
								<Link
									to="/benchmark-test"
									onClick={handleNavClick}>
									Take benchmark test
								</Link>
							</Button>
						</div>
					)}
				</nav>
			</SheetContent>
		</Sheet>
	);
}
